export interface IPeriod {
    startTime: Date;
    endTime: Date;
    duration: number;
    text:string;

    

}

export class Period implements IPeriod {

    endTime: Date = new Date();
    text:string=""


    constructor(public startTime: Date, public duration: number) {
        this.startTime = startTime ;
        this.duration = duration ;
        this.endTime = Period.add_minutes(this.startTime, this.duration);
    }

    static overlaps(p1: IPeriod, p2:IPeriod): boolean {
        return ( (p1.startTime <= p2.endTime && p1.endTime >= p2.startTime) 
              || (p2.startTime <= p1.endTime && p2.endTime >= p1.startTime));
    }

    static overlapping_periods(period: IPeriod, periods: IPeriod[]): IPeriod[] {
        const common:IPeriod[] = []
        for (const p of periods) {
            if (Period.overlaps(period, p)) {
                common.push(p); // Overlap found
            }
        }
        return common; // No overlap found
    }

    static add_minutes(date: Date, minutes: number):Date {
        return new Date(date.getTime() + ((minutes) * 60000));
    }

    static format_hour(date: Date) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    static format_date(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}.${month}.${day}`;
    }
}

export class OutagePeriod extends Period implements IPeriod {

    constructor(startTime: Date, duration: number, text: string) {
        const date = new Date(startTime)
        date.setMinutes(1)
        const d = duration -2
        super(date, d)
        this.text = text
    }
}

export class TimeGridPeriod extends Period implements IPeriod {
    available: number = 1;
    formatted_hour: string = "";
    formatted_date: string = "";
 
    constructor(startTime: Date, duration: number) {
        super(startTime, duration); // Call the constructor of the base class (Period)
        // Initialize additional properties
        this.available = 1;
        this.formatted_hour = Period.format_hour(this.startTime);
        this.formatted_date = Period.format_date(this.startTime);
    }


    
}